import people from "../../../assets/img/projects/Genome/icons/people.svg";
import mail from "../../../assets/img/projects/Genome/icons/mail.svg";
import arrowUp from "../../../assets/img/projects/Genome/icons/arrow-up.svg";
import paper from "../../../assets/img/projects/Genome/icons/paper.svg";
import clock from "../../../assets/img/projects/Genome/icons/clock.svg";
import plus from "../../../assets/img/projects/Genome/icons/plus.svg";
import arrowDown from "../../../assets/img/projects/Genome/icons/arrow-down.svg";
import home from "../../../assets/img/projects/Genome/icons/home.svg";
import shop from "../../../assets/img/projects/Genome/icons/shop.svg";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

export default function Palette() {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 75%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });

      const coloGrid = containerRef.current.querySelector(".colo-grid");
      const icoGrid = containerRef.current.querySelector(".ico-grid");

      tl.fromTo(
        coloGrid,
        { opacity: 0, y: 50, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 1,
          ease: "power2.out",
        }
      ).fromTo(
        icoGrid,
        { opacity: 0, y: 50, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 1,
          ease: "power2.out",
        },
        "-=0.8"
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  const icons = [
    people,
    mail,
    arrowUp,
    paper,
    clock,
    plus,
    arrowDown,
    home,
    shop,
  ];

  return (
    <div className="Genome-palette" ref={containerRef}>
      <h2 className="colo-title">{t("genome.palette.colorimetry")}</h2>
      <h2 className="ico-title">{t("genome.palette.iconography")}</h2>
      <div className="colo-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="ico-grid">
        {icons.map((icon, index) => (
          <img key={index} src={icon} alt="" />
        ))}
      </div>
    </div>
  );
}
